export default __webpack_public_path__ + "static/media/tick.6b04ae60.gif";